import { render } from "./stepCreateRMA.vue?vue&type=template&id=4fe99a2a&scoped=true"
import script from "./stepCreateRMA.vue?vue&type=script&lang=js"
export * from "./stepCreateRMA.vue?vue&type=script&lang=js"

import "./stepCreateRMA.vue?vue&type=style&index=0&id=4fe99a2a&lang=scss&scoped=true"
import "./stepCreateRMA.vue?vue&type=style&index=1&id=4fe99a2a&lang=css"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe99a2a"]])

export default __exports__